import { render, staticRenderFns } from "./AbaPoliticaComercial.vue?vue&type=template&id=0a0bf1dd&scoped=true"
import script from "./AbaPoliticaComercial.vue?vue&type=script&lang=js"
export * from "./AbaPoliticaComercial.vue?vue&type=script&lang=js"
import style0 from "./AbaPoliticaComercial.vue?vue&type=style&index=0&id=0a0bf1dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0bf1dd",
  null
  
)

export default component.exports